<script lang="ts">
  import Footer from './footer.svelte';
  import { MenuLinks } from './menu-links';
  import { mobileMenuActivity } from '@shared/lib/stores';
</script>

<div
  class="dark:bg-store-dark fixed top-0 z-10 h-full w-full overflow-auto overflow-y-auto overflow-x-hidden bg-white transition-transform duration-700 ease-in lg:hidden"
  class:-translate-y-full="{!$mobileMenuActivity}"
>
  <div class="flex h-full w-full flex-col p-5 md:p-8">
    <MenuLinks />

    <div class="mt-4">
      <Footer />
    </div>
  </div>
</div>
